import React, { useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import "./App.css";

import Navbar from "./components/Navbar";
import Footer from "./components/Footer";

import Home from "./pages/Home";
import Acerca from "./pages/Acerca";
import Instrumentacion from "./pages/Instrumentacion";
import Procesamiento from "./pages/Procesamiento";
import Estaciones from "./pages/Estaciones";
import Boletines from "./pages/Boletines";
import ReportesEspeciales from "./pages/ReportesEspeciales";
import Noticias from "./pages/Noticias";
import Divulgacion from "./pages/Divulgacion";
import Preguntas from "./pages/Preguntas";
import Efectos from "./pages/Efectos";
import Contacto from "./pages/Contacto";
import Citarnos from "./pages/Citarnos";
import AvisoLegal from "./pages/AvisoLegal";

function MatomoTracker() {
  const location = useLocation();
  useEffect(() => {
    if (window._paq) {
      window._paq.push(["setCustomUrl", window.location.href]);
      window._paq.push(["setDocumentTitle", document.title]);
      window._paq.push(["trackPageView"]);
    }
  }, [location]);
  return null;
}

function App() {
  return (
    <Router basename="/">
      <MatomoTracker />
      <div className="App">
        <Navbar />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/acerca" element={<Acerca />} />
            <Route path="/instrumentacion" element={<Instrumentacion />} />
            <Route path="/procesamiento" element={<Procesamiento />} />
            <Route path="/estaciones" element={<Estaciones />} />
            <Route path="/noticias" element={<Noticias />} />
            <Route path="/boletines" element={<Boletines />} />
            <Route
              path="/reportes-especiales"
              element={<ReportesEspeciales />}
            />
            <Route path="/divulgacion" element={<Divulgacion />} />
            <Route path="/preguntas" element={<Preguntas />} />
            <Route path="/efectos" element={<Efectos />} />
            <Route path="/contacto" element={<Contacto />} />
            <Route path="/citarnos" element={<Citarnos />} />
            <Route path="/aviso-legal" element={<AvisoLegal />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
